import { Model } from 'modules/core/lib/mobx-rest'

interface IReview {
  [key: string]: any
}
class Review extends Model<IReview> {
  static urlRoot() {
    return '/attendance/reviews'
  }
}

export default Review
